/* RESPONSIBLE TEAM: team-actions */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default class ActionHeader extends Fragment {
  @attr('string') declare name: string;
  @attr('string') declare value: string;
}
